export default {
      id: "bluetooth-rotate-90-usage",
      viewBox: "0 0 30 52",
      url: __webpack_public_path__ + "img/icons.svg#bluetooth-rotate-90",
      toString: function () {
        return this.url;
      }
    }